module.exports = __webpack_public_path__ + "img/shop.7f6be883.png";